<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header justify-content-between border-0">
        <h5 class="card-title font-bold">
          {{ $route.params.id ? "ویرایش مطلب" : "مطلب جدید" }}
        </h5>
        <Back ref="back" />
      </div>
      <div class="card-body">
        <b-form ref="postForm" @submit.prevent="submitHandler">
          <BFormGroup :disabled="disabled">
            <label>عنوان<span class="text-danger">*</span></label>
            <BFormInput v-model="postForm.title" type="text" />
          </BFormGroup>
          <BFormGroup :disabled="disabled">
            <label>تصویر<span class="text-danger">*</span></label>
            <b-form-file
              v-model="postForm.main_image"
              placeholder="فایلی انتخاب نشده"
              type="file"
            />
          </BFormGroup>
          <BFormGroup :disabled="disabled">
            <label>خلاصه<span class="text-danger">*</span></label>
            <b-form-textarea v-model="postForm.summary" />
          </BFormGroup>
          <BFormGroup
            v-if="categoriesOption && categoriesOption.length"
            :disabled="disabled"
          >
            <label>دسته بندی<span class="text-danger">*</span></label>
            <Multiselect
              v-model="postForm.post_category_id"
              open-direction="bottom"
              :options="categoriesOption"
              :label="'name'"
              track-by="id"
              placeholder="انتخاب کنید"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              :disabled="disabled"
            >
              <template slot="noOptions">
                موردی یافت نشد
              </template>
              <template slot="noResult">
                موردی یافت نشد
              </template>
            </Multiselect>
          </BFormGroup>
          <BFormGroup :disabled="disabled">
            <label>متن<span class="text-danger">*</span></label>
            <Ckeditor id="product_description" v-model="postForm.body" />
          </BFormGroup>
          <BFormGroup :disabled="disabled">
            <label>توضیحات متا</label>
            <b-form-textarea v-model="postForm.meta_description" />
          </BFormGroup>
          <BFormGroup :disabled="disabled">
            <label>انتشار در</label>
            <date-picker
              type="date"
              v-model="postForm.published_at"
              format="YYYY/MM/DD"
              display-format="jYYYY/jMM/jDD"
            />
          </BFormGroup>
          <BFormGroup :disabled="disabled">
            <label>ویژه</label>
            <b-form-checkbox
              v-model="postForm.special"
              value="1"
              unchecked-value="0"
            />
          </BFormGroup>
          <BFormGroup :disabled="disabled">
            <label>وضعیت</label>
            <Multiselect
              v-model="postForm.status"
              placeholder="انتخاب کنید"
              open-direction="bottom"
              :options="statusOption"
              :label="'label'"
              track-by="value"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              :disabled="disabled"
            >
              <template slot="noOptions">
                موردی یافت نشد
              </template>
              <template slot="noResult">
                موردی یافت نشد
              </template>
            </Multiselect>
          </BFormGroup>
          <b-button
            type="submit"
            :disabled="disabled"
            variant="primary"
            v-text="mode === 'create' ? 'ثبت' : 'ویرایش'"
          />
        </b-form>
      </div>
    </div>
  </main>
</template>
<script>
import PostCreateEditImpl from "@@/core/pages/post/PostCreateEdit/PostCreateEditImpl";
export default {
  extends: PostCreateEditImpl,
};
</script>
